/**
 * Brand constants — consumed by Layout, Login, Careers, etc.
 * Logo + name come from public/company endpoint at runtime; static fallbacks below.
 */
export const BRAND = {
  name: "Solemnity",
  fullName: "Solemnity IT Healthcare Solutions Pvt Ltd",
  tagline: "Healthcare-grade systems · People-first culture",
  logoUrl: "/assets/solemnity-logo.png",
};
